module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAURJREFUeF7tmFEOgkAMRLvX8kePgvfg13Ool9FjrSGBhBBRPrad2XT4JrTzOtMFiiW/SnL9JgByQHICikByA2gJKgKKQHICikByA+gUUAQUgeQEFIHkBtApoAhER+B0q4NVO7/Gco2u/a1eqANm8fe5kQcDhDAAG/HLMOAQQgDsiLdq9nyPZUBGwR0As/gJvCsAdvGuAHoQ7wagF/EuAHoS3xzAnniPLf8aS5P91eQhk8BI8VM9AWBzQLQL6Byw5PxHFOCvvWEfQz1BaLYEt3R7geAG4M9OoImDK4AeILgDYIcQAmAPQor/AevluF6MDOKbfwsceeefINRqF/SfoKXXsAgcgYO4RwAQ1JlqygFM00D0IgcgqDPVlAOYpoHoRQ5AUGeqKQcwTQPRixyAoM5UUw5gmgaiFzkAQZ2pphzANA1ELx9myodB3yI+QAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/community/arrows-left.png
// module id = xGFb
// module chunks = 15